<template>
  <div class="page-wrap">
    <div class="wraper">
      <div class="steps">
        <img class="img" :src="img1" />
        <img style="width: 100%;" :src="img2" />
      </div>
    </div>
   <bottom style="flex: 0 0 2.2rem;"></bottom>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img1: `${process.env.BASE_URL}ImgFiles/ws.png`,
      img2: `${process.env.BASE_URL}ImgFiles/bg.jpg`,
    }
  },
};
</script>

<style scoped>
.page-wrap {
  
  position: absolute;
  bottom: 0;
  overflow-y: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10;
  background-color: #fff;
}
.steps {
  padding-bottom: 2rem;
  padding-top: 1.82rem;
}
.img {
  width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
}
</style>